import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Users, Zap, Trophy, Headphones } from 'lucide-react';

const Discord = () => {
  const { t } = useLanguage();
  const [sectionRef, isVisible] = useScrollAnimation(0.1);

  // Discord invite link - replace with your actual Discord invite
  const discordInviteUrl = "https://discord.gg/P7EPKeMdVy";


  const benefits = [
    {
      icon: Zap,
      title: t('discord.benefits.updates'),
      description: t('discord.benefits.updatesDesc'),
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: Users,
      title: t('discord.benefits.community'),
      description: t('discord.benefits.communityDesc'),
      color: 'from-blue-500 to-cyan-500'
    },
    // {
    //   icon: Trophy,
    //   title: t('discord.benefits.events'),
    //   description: t('discord.benefits.eventsDesc'),
    //   color: 'from-purple-500 to-pink-500'
    // },
    {
      icon: Headphones,
      title: t('discord.benefits.support'),
      description: t('discord.benefits.supportDesc'),
      color: 'from-green-500 to-emerald-500'
    }
  ];


  // někde nahoře v komponentě
  const getWidthClass = (count) => {
    if (count === 1) return "w-full";

    if (count === 2)
      return "w-full md:w-[calc(50%-1rem)]"; // odpočet gap 6 (1rem)

    if (count === 3)
      return "w-full md:w-[calc(33.333%-1rem)]";

    if (count === 4)
      return "w-full md:w-[calc(25%-1rem)]";

    return "w-full md:w-[calc(25%-1rem)]";
  };


  const widthClass = getWidthClass(benefits.length);

  return (
    <section id="discord" ref={sectionRef} className="py-20 bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-48 w-96 h-96 bg-purple-900/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 -right-48 w-96 h-96 bg-blue-900/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 pb-2 bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
            {t('discord.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">{t('discord.subtitle')}</p>
        </div>

        {/* Main Discord Card */}
        <div className={`mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} style={{ transitionDelay: '200ms' }}>
          <div className="bg-gradient-to-br from-gray-900/90 to-gray-900/50 backdrop-blur-sm border border-red-900/20 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 gap-8 items-center ">
              {/* Left side - Discord Logo and Info */}
              <div className="text-center">
                {/* Discord Logo */}
                <div className="flex justify-center mb-6">
                  <div className="w-24 h-24 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-2xl shadow-purple-500/50">
                    <svg
                      className="w-14 h-14 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                    </svg>
                  </div>
                </div>

                <h3 className="text-3xl font-bold text-white mb-4">Silly Hat Studio</h3>

                {/* Stats
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center mb-6">
                  <div className="flex items-center justify-center space-x-3 bg-gray-800/30 rounded-lg px-4 py-3">
                    <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse flex-shrink-0"></div>
                    <div className="text-left">
                      <p className="text-xl sm:text-2xl font-bold text-white leading-tight">1.2K+</p>
                      <p className="text-xs sm:text-sm text-gray-400 whitespace-nowrap">{t('discord.members')}</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center space-x-3 bg-gray-800/30 rounded-lg px-4 py-3">
                    <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse flex-shrink-0"></div>
                    <div className="text-left">
                      <p className="text-xl sm:text-2xl font-bold text-white leading-tight">350+</p>
                      <p className="text-xs sm:text-sm text-gray-400 whitespace-nowrap">{t('discord.online')}</p>
                    </div>
                  </div>
                </div> */}

                {/* Join Button */}
                <a
                  href={discordInviteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-3 px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold rounded-lg transition-all hover:scale-105 shadow-lg hover:shadow-purple-500/50"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                  </svg>
                  <span>{t('discord.joinButton')}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Flexbox */}
        <div className="flex flex-wrap gap-6 justify-center ">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`
        ${widthClass}
        transition-all duration-700
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
      `}
              style={{ transitionDelay: `${400 + index * 100}ms` }}
            >
              <div className="bg-gray-900/50 backdrop-blur-sm border border-red-900/20 rounded-xl p-6 hover:border-red-600/50 transition-all hover:shadow-xl hover:shadow-red-900/20 h-full group">
                <div
                  className={`
            w-12 h-12 rounded-lg bg-gradient-to-br ${benefit.color}
            flex items-center justify-center mb-4
            group-hover:scale-110 transition-transform
          `}
                >
                  <benefit.icon className="w-6 h-6 text-white" />
                </div>

                <h4 className="text-lg font-bold text-white mb-2 group-hover:text-red-400 transition-colors">
                  {benefit.title}
                </h4>

                <p className="text-gray-400 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
};

export default Discord;
